import React from "react";
// import SockJsClient from 'react-stomp';


// reactstrap components
import {UncontrolledAlert } from 'reactstrap';

class Insights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: this.props.notifications,
      example:[]
    };
  }

  getFullDate(UTCtime){
    const epoch = new Date(UTCtime);
    // var day = this.formatDate(epoch);
    var time = this.formatTime(epoch);
    return epoch.toDateString() + " - " + time;
  }

  formatDate(date){
    return date.getFullYear() + "/" + this.fixTime(date.getMonth()+1) + "/" + this.fixTime(date.getDate());
  }

  formatTime(date){
    let hours = date.getHours();
    let ampm = hours > 12 ? "PM" : "AM";
    hours += hours > 12 ? -12 : 0;
    return hours + ":" + this.fixTime(date.getMinutes()) + " " + ampm;
  }

  round(num){
    return Math.round(num * 100) / 100;
  }

  fixTime(d){
    return ('0' + d).slice(-2);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.notifications.length !== prevProps.notifications.length) {
      console.log("update");
      this.setState({
        notifications: this.props.notifications,
      })
    }
  }

  render() {

      const receivedNotifications = this.state.notifications.map(notification => (
          <UncontrolledAlert key = {notification.id} style={{width: '90%'}} className="alert-with-icon" color={notification.level}>
            <span
              className="tim-icons icon-bell-55"
              data-notify="icon"
            />
            <span data-notify="title"><b>
              {notification.name}
            </b></span>
            <span data-notify="message">
              {notification.info}
            </span>
            <span>{this.getFullDate(notification.timeStamp)}</span>

          </UncontrolledAlert>
      ));

      const exampleNotifications = this.state.example.map(notification => (
          <UncontrolledAlert key = {notification.id} style={{width: '90%'}} className="alert-with-icon" color="AgriBoostGreen">
            <span
              className="tim-icons icon-bell-55"
              data-notify="icon"
            />
          <span>{this.getFullDate(notification.timestamp)}</span>
            <span data-notify="message">
              {notification.content}
            </span>
          </UncontrolledAlert>
      ));
    return (
      <>
      <div className="content">
      <div className="row">
      <div className="column">
        {exampleNotifications}
        {receivedNotifications}
      </div>
      </div>
      </div>
      </>
    );
  }
}

export default Insights;
